var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMeldrPoweredByDsLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 184.955,
    height: 29,
    viewBox: "0 0 184.955 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1195",
    "data-name": "Group 1195",
    transform: "translate(-146 -728.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_331",
    "data-name": "Group 331",
    transform: "translate(40.8 4.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Horizontal-Color",
    transform: "translate(197.32 742)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M182.923.12l-3.271,6.42-.793,1.547h1.819l2.245-4.4,2.245,4.4h1.819Z",
    transform: "translate(-154.992 -0.104)",
    fill: "#241345"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_113",
    "data-name": "Rectangle 113",
    width: 1.623,
    height: 7.969,
    transform: "translate(59.93 0.012)",
    fill: "#241345"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M3.973.131,0,.12V8.087H3.983a3.9,3.9,0,0,0,2.8-1.173c.079-.079.159-.159.227-.239A3.973,3.973,0,0,0,3.973.131ZM6.3,4.114A2.329,2.329,0,0,1,3.971,6.44H1.647V1.789H3.971A2.327,2.327,0,0,1,6.3,4.114Z",
    transform: "translate(0 -0.104)",
    fill: "#241345"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M257.963,3.84a.7.7,0,0,0-.049-.056,2.565,2.565,0,0,0-1.894-.837h-2.765a.567.567,0,0,1-.559-.559V2.345a.567.567,0,0,1,.559-.559h4.683V.12h-4.683a2.214,2.214,0,0,0-2.206,2.217v.044a2.173,2.173,0,0,0,.384,1.25,2.1,2.1,0,0,0,.284.355,2.194,2.194,0,0,0,1.537.622h2.765a.91.91,0,0,1,0,1.82H251.3V8.087h4.725A2.567,2.567,0,0,0,258,3.882.2.2,0,0,1,257.963,3.84Z",
    transform: "translate(-217.548 -0.104)",
    fill: "#241345"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M60.4,6.54,59.61,8.087h1.819l2.245-4.4,2.245,4.4h1.819L63.673.12Z",
    transform: "translate(-51.655 -0.104)",
    fill: "#241345"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M317.666.09a3.986,3.986,0,1,0,3.986,3.991A3.986,3.986,0,0,0,317.666.09Zm2.329,3.991a2.327,2.327,0,1,1-2.327-2.326,2.327,2.327,0,0,1,2.327,2.326Z",
    transform: "translate(-271.821 -0.078)",
    fill: "#241345"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M542.34,1.623h3.083V7.995h1.623V1.623h3.083V0H542.34Z",
    transform: "translate(-469.968)",
    fill: "#241345"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M123.593,8.087h1.623V1.743H128.3V.12H120.51V1.743h3.083Z",
    transform: "translate(-104.429 -0.104)",
    fill: "#241345"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M475.37,4a4,4,0,0,0,4,4h3.507V6.331h-3.512a2.349,2.349,0,0,1-2.179-1.5h4.5V3.165h-4.5a2.345,2.345,0,0,1,2.178-1.5h3.507V0h-3.506a4,4,0,0,0-4,4Z",
    transform: "translate(-411.934)",
    fill: "#241345"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M386.3,1.75h3.123V.09H386.3a3.986,3.986,0,1,0,0,7.971h3.123V6.4H386.3a2.326,2.326,0,0,1,0-4.652Z",
    transform: "translate(-331.293 -0.078)",
    fill: "#241345"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M612.7,2.618,610.678,0H608.6l3.127,4.049.153.189V7.995h1.644V4.216L616.781,0h-2.066Z",
    transform: "translate(-527.386)",
    fill: "#241345"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_26",
    "data-name": "Ellipse 26",
    cx: 1.288,
    cy: 1.288,
    r: 1.288,
    transform: "translate(90.259 0)",
    fill: "#ee3d23"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_27",
    "data-name": "Ellipse 27",
    cx: 1.288,
    cy: 1.288,
    r: 1.288,
    transform: "translate(90.259 5.419)",
    fill: "#ee3d23"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_Light_Theme_6._Overline_Overline",
    "data-name": "\\uD83C\\uDF15 Light Theme/6. Overline/Overline",
    transform: "translate(197 737)",
    fill: "rgba(0,0,0,0.87)",
    fontSize: 10,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500,
    letterSpacing: "0.15em",
    opacity: 0.88
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "POWERED BY"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1150",
    "data-name": "Group 1150",
    transform: "translate(-22.669 657.358)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M185.936,129.489a6.693,6.693,0,0,0-4.39-1.26,6.112,6.112,0,0,0-5,1.965,6.672,6.672,0,0,0-1.3,4.333,4.213,4.213,0,0,0,1.317,3.377,4.5,4.5,0,0,0,3.006.947,4.328,4.328,0,0,0,4.323-4.323.877.877,0,0,0-1.755,0,2.572,2.572,0,0,1-2.569,2.569c-1.8,0-2.569-.768-2.569-2.569a5,5,0,0,1,.9-3.221,4.478,4.478,0,0,1,3.642-1.322,5.073,5.073,0,0,1,3.276.862c.853.7,1.267,1.9,1.267,3.682,0,3.147-.385,4.878-1.328,5.975-.679.79-2.09,1.84-6.487,1.84a7.194,7.194,0,0,1-5.4-1.88c-2.56-2.6-2.487-7.592-2.429-11.6.009-.6.017-1.157.017-1.7a7.783,7.783,0,0,1,.413-2.508l6.051,1.992a1.053,1.053,0,0,0,1.382-1v-.221a1.053,1.053,0,0,1,1.382-1L186.3,126.6a1.051,1.051,0,0,0,1.368-1.172,9.512,9.512,0,0,0-9.363-7.839h-.031a9.58,9.58,0,0,0-9.569,9.569c0,.53-.008,1.086-.017,1.675-.063,4.34-.142,9.741,2.933,12.862a8.958,8.958,0,0,0,6.653,2.4c3.949,0,6.361-.756,7.818-2.451.91-1.058,1.752-2.653,1.752-7.118C187.844,132.224,187.2,130.529,185.936,129.489Z",
    transform: "translate(0 -43.954)",
    fill: "#001276"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M430.911,78.935c-.69-4.129-4.853-7.376-10.054-7.79a1.05,1.05,0,0,0-1.128,1.05v6.9a1.053,1.053,0,0,0,1.053,1.053h9.088A1.049,1.049,0,0,0,430.911,78.935Zm-4.9-1.322a1.452,1.452,0,1,1,1.452-1.452A1.452,1.452,0,0,1,426.01,77.613Z",
    transform: "translate(-237.591)",
    fill: "#001276"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1149",
    "data-name": "Group 1149",
    transform: "translate(194.712 82.206)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M666.18,348.708a4.934,4.934,0,0,0-2.185-.4,7.351,7.351,0,0,0-1.384.132,6.145,6.145,0,0,0-1.328.414q-.23.1-.458.228a2.746,2.746,0,0,0-.559-.369,4.935,4.935,0,0,0-2.185-.4,9.614,9.614,0,0,0-1.045.057,9.015,9.015,0,0,0-1.017.169,7.637,7.637,0,0,0-.979.292,9.571,9.571,0,0,0-.932.4v8.645h1.356V349.9a9.589,9.589,0,0,1,1.262-.283,8.062,8.062,0,0,1,1.205-.094,3.523,3.523,0,0,1,1.356.217,1.71,1.71,0,0,1,.753.565,2.043,2.043,0,0,1,.33.725,3.27,3.27,0,0,1,.085.716v6.121h1.356V351.75a4.6,4.6,0,0,0-.251-1.582,4.367,4.367,0,0,1,1.079-.471,4.573,4.573,0,0,1,1.205-.17,3.523,3.523,0,0,1,1.356.217,1.709,1.709,0,0,1,.753.565,2.041,2.041,0,0,1,.33.725,3.263,3.263,0,0,1,.085.716v6.121h1.356V351.75a4.313,4.313,0,0,0-.367-1.864A2.492,2.492,0,0,0,666.18,348.708Z",
    transform: "translate(-654.108 -344.499)",
    fill: "#001276"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M963.175,350.808a3.719,3.719,0,0,0-1.309-1.827,3.965,3.965,0,0,0-2.42-.678,3.876,3.876,0,0,0-3.023,1.215,5.271,5.271,0,0,0-1.1,3.644,6.442,6.442,0,0,0,.527,2.769,3.649,3.649,0,0,0,1.507,1.667,4.619,4.619,0,0,0,2.317.556,8.887,8.887,0,0,0,1.8-.169,6.637,6.637,0,0,0,1.5-.49V356.1a5.569,5.569,0,0,1-.866.414,5.807,5.807,0,0,1-1.073.292,7.34,7.34,0,0,1-1.281.1,2.863,2.863,0,0,1-2.251-.895,3.791,3.791,0,0,1-.8-2.608h6.856A7.659,7.659,0,0,0,963.175,350.808Zm-6.177.254a2.072,2.072,0,0,1,.913-1.177,3.136,3.136,0,0,1,1.535-.339,2.594,2.594,0,0,1,1.987.7,3.057,3.057,0,0,1,.7,1.921H956.76A4.979,4.979,0,0,1,957,351.062Z",
    transform: "translate(-939.162 -344.499)",
    fill: "#001276"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_805",
    "data-name": "Rectangle 805",
    width: 1.356,
    height: 12.976,
    transform: "translate(26.932 0.396)",
    fill: "#001276"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M1235.617,281.755c-.133-.051-.277-.1-.433-.149a11.105,11.105,0,0,0-1.111-.283,5.1,5.1,0,0,0-.979-.113,3.973,3.973,0,0,0-3.23,1.271,5.216,5.216,0,0,0-1.064,3.456,6.863,6.863,0,0,0,.424,2.627,3.686,3.686,0,0,0,2.514,2.279,5.642,5.642,0,0,0,1.431.2,8.047,8.047,0,0,0,1.243-.1,6.463,6.463,0,0,0,1.243-.32,2.6,2.6,0,0,0,.951-.584,1.218,1.218,0,0,0,.367-.895V277.387h-1.356Zm0,7.253q0,.339-.725.565a5.75,5.75,0,0,1-1.7.226,2.8,2.8,0,0,1-1.865-.546,2.7,2.7,0,0,1-.866-1.422,7.564,7.564,0,0,1-.226-1.893,5.178,5.178,0,0,1,.292-1.817,2.532,2.532,0,0,1,.923-1.224,2.811,2.811,0,0,1,1.648-.443,5.474,5.474,0,0,1,1.271.16,4.636,4.636,0,0,1,1.253.5Z",
    transform: "translate(-1197.968 -277.387)",
    fill: "#001276"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M1448.52,305.046l-3.413-5.209a3.327,3.327,0,0,0,1.134-.423,3.4,3.4,0,0,0,1.262-1.337,4.056,4.056,0,0,0,.452-1.94,3.682,3.682,0,0,0-.932-2.731,3.8,3.8,0,0,0-2.778-.923h-5.16v12.562h1.356V299.98h3.2l3.278,5.066Zm-8.08-11.281h3.654a2.41,2.41,0,0,1,1.978.669,2.828,2.828,0,0,1,.527,1.8,2.334,2.334,0,0,1-.706,1.836,3.357,3.357,0,0,1-2.27.631h-3.183Z",
    transform: "translate(-1396.972 -291.674)",
    fill: "#001276"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M419.729,132.582v4.658a1.053,1.053,0,0,0,1.053,1.053h4.143A9.536,9.536,0,0,0,419.729,132.582Z",
    transform: "translate(-237.591 -58.144)",
    fill: "#001276"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeldrPoweredByDsLogin);
export default __webpack_public_path__ + "static/media/meldr-powered-by-ds-login.fed31acc332bfe5dc88a797bec52d11b.svg";
export { ForwardRef as ReactComponent };